import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import Layout from '../components/layout/Layout';

const NotFound = () => {
  return (
    <Layout>
      <section className="section-padding">
        <div className="container-custom text-center">
          <h1 className="font-display text-8xl font-bold text-[#1e3a5f] mb-4">404</h1>
          <h2 className="font-display text-2xl md:text-3xl font-semibold text-[#475569] mb-6">
            Page Not Found
          </h2>
          <p className="text-[#475569] max-w-md mx-auto mb-8">
            The page you are looking for doesn't exist or has been moved. Let us help you find your way.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="bg-[#1e3a5f] hover:bg-[#2563eb] text-white">
                <Home className="w-4 h-4 mr-2" />
                Go Home
              </Button>
            </Link>
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              className="border-[#1e3a5f] text-[#1e3a5f]"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
